module.exports = __webpack_public_path__ + "img/section4Logo1.b7153826.svg";